import {AfterViewInit, ElementRef, Input, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';

import * as _ from 'lodash';

import {FormData} from '../../classes/data';
import {FormSchema} from '../../classes/schema';
import {FormMessages, FormValidationBooleanFunction} from '../../form.validators';
import {RangeStatic} from 'quill';

export abstract class BaseComponent<T> implements AfterViewInit {
  @ViewChild('nativeElement', {static: false}) elementRef: ElementRef;

  @Input('form') form: FormData;

  @Input('schema') set setSchema(schema: FormSchema) {
    this.schema = schema;
    this.control = this.schema.getControl();
  }

  public get value(): T {
    return this.schema.value;
  }

  public set value(value: T) {
    this.schema.setValue(value, true);
  }

  public get errors(): any {
    return this.schema.errors;
  }

  public schema: FormSchema;
  public control: FormControl;

  public ngAfterViewInit() {
    this.setNativeElement();
    this.onInit(this);
  }

  public onReset() {
  }

  public onValueSetted(new_value: T) {
  }

  public setErrors(errors: any) {
    this.schema.setErrors(errors);
  }

  public clear() {
    this.value = null;
  }

  public focus() {
    this.elementRef.nativeElement.focus();
  }

  public isRequired(): boolean {
    const validations = this.schema.validations;
    return validations && validations.required
      ? !!(_.isFunction(validations.required)
        ? (<FormValidationBooleanFunction>validations.required)(
          this.schema,
          this.form
        )
        : <boolean>validations.required)
      : false;
  }

  public isRequiredTrue(): boolean {
    const validations = this.schema.validations;
    return validations && validations.requiredTrue
      ? !!(_.isFunction(validations.requiredTrue)
        ? (<FormValidationBooleanFunction>validations.requiredTrue)(
          this.schema,
          this.form
        )
        : <boolean>validations.requiredTrue)
      : false;
  }

  public isFocused(): boolean {
    return this.schema.focused;
  }

  public isValid(): boolean {
    return this.allowValidate() && this.control.valid;
  }

  public isInvalid(): boolean {
    return this.allowValidate() && this.control.invalid;
  }

  public hasError(): boolean {
    return this.allowValidate() && this.control.invalid;
  }

  public allowValidate(): boolean {
    return this.control && this.control.dirty && this.control.touched;
  }

  public formatErrors(): string {
    const errors = this.errors;

    if (_.isEmpty(errors)) {
      return '';
    }

    const message = [];
    _.forEach(errors, (error: any, key: string) => {
      const error_message: string | void = this.getErrorMessage(key, error);
      if (!_.isEmpty(error_message)) {
        message.push(error_message);
      }
    });
    return message.join(', ');
  }

  public getErrorMessage(key: string, error: any): string {
    const message =
      this.schema.validation_messages && this.schema.validation_messages[key]
        ? this.schema.validation_messages[key]
        : FormMessages[key];

    return message
      ? _.isFunction(message)
        ? message(error, this.schema)
        : message
      : null;
  }

  public onInit(event?: any) {
    if (this.schema.events && _.isFunction(this.schema.events.onInit)) {
      this.schema.events.onInit({
        form: this.form,
        schema: this.schema,
        eventRef: event
      });
    }
  }

  public onKeydown(event?: any) {
    if (this.schema.events && _.isFunction(this.schema.events.onKeydown)) {
      this.schema.events.onKeydown({
        form: this.form,
        schema: this.schema,
        eventRef: event
      });
    }
  }

  public onKeyup(event?: any) {
    if (this.schema.events && _.isFunction(this.schema.events.onKeyup)) {
      this.schema.events.onKeyup({
        form: this.form,
        schema: this.schema,
        eventRef: event
      });
    }
  }

  public onKeypress(event?: any) {
    if (this.schema.events && _.isFunction(this.schema.events.onKeypress)) {
      this.schema.events.onKeypress({
        form: this.form,
        schema: this.schema,
        eventRef: event
      });
    }
  }

  public onChange(event?: any) {
    this.form.updateControlDisabled();
    this.schema.setCustomError(null);
    if (this.schema.events && _.isFunction(this.schema.events.onChange)) {
      setTimeout(
        () =>
          this.schema.events.onChange({
            form: this.form,
            schema: this.schema,
            eventRef: event
          }),
        50
      ); // O timeout previde de executar o evento antes de aplicar as mudanÃ§as (updateValueAndValidity) na controller.
    }
  }

  public onFocus(event?: any) {
    this.schema.focused = true;
    this.control.markAsTouched({onlySelf: true});
    if (this.schema.events && _.isFunction(this.schema.events.onFocus)) {
      this.schema.events.onFocus({
        form: this.form,
        schema: this.schema,
        eventRef: event
      });
    }
  }

  public onBlur(event?: any) {
    this.schema.focused = false;
    if (this.schema.events && _.isFunction(this.schema.events.onBlur)) {
      this.schema.events.onBlur({
        form: this.form,
        schema: this.schema,
        eventRef: event
      });
    }
  }

  protected setNativeElement() {
    this.schema.component = this;
    if (this.elementRef) {
      this.schema.nativeElement = this.elementRef.nativeElement;
    }
  }


  setQuillInstance(quillInstance) {
    console.log(quillInstance);
    this.schema.quillEditor = quillInstance;
  }
}
